var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coursesPage"},[_c('topNav'),_c('b-row',[_c('b-col',{attrs:{"lg":"2"}}),_c('b-col',{attrs:{"lg":"10","md":"10","offset-md":"1","sm":"10","cols":"12"}},[_c('CourseContent')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }